/* ============================================================================
   ARDAM / K9 RAW - Quiz Recommendation Engine
   Built directly from the live Shopify catalog (status:active). All variant IDs,
   handles, SKUs and prices are real. Logic locked 3 Jun 2026.

   Pure functions, no DOM. Returns a recommendation object the UI renders.
   ============================================================================ */

/* ---------------------------------------------------------------------------
   CATALOG MAP - real data
   --------------------------------------------------------------------------- */

// DOG adult weekly packages: weight band -> handle. (Handle kg = UPPER bound.)
var DOG_WEEKLY = [
  {max:5,    label:"Up to 5kg",  handle:"5kg-dog-weekly-raw-dog-food"},
  {max:7.5,  label:"5 to 7.5kg", handle:"7-5kg-dog-weekly-raw-dog-food"},
  {max:10,   label:"7.5 to 10kg",handle:"10kg-dog-weekly-raw-dog-food"},
  {max:15,   label:"10 to 15kg", handle:"15kg-dog-weekly-raw-dog-food"},
  {max:20,   label:"15 to 20kg", handle:"20kg-dog-weekly-raw-dog-food"},
  {max:25,   label:"20 to 25kg", handle:"25kg-dog-weekly-raw-dog-food"},
  {max:30,   label:"25 to 30kg", handle:"30kg-dog-weekly-raw-dog-food"},
  {max:35,   label:"30 to 35kg", handle:"35kg-dog-weekly-raw-dog-food"},
  {max:40,   label:"35 to 40kg", handle:"40kg-dog-weekly-raw-dog-food"},
  {max:45,   label:"40 to 45kg", handle:"45kg-dog-weekly-raw-dog-food"},
  {max:Infinity, label:"45 to 50kg", handle:"50kg-dog-weekly-raw-dog-food"}
];

// PUPPY age bands -> handle suffix appended to the weekly handle.
var PUPPY_AGE_BANDS = [
  {maxMonths:4,  label:"2 to 4 months",  suffix:"-2-4-months"},
  {maxMonths:6,  label:"4 to 6 months",  suffix:"-4-6-months"},
  {maxMonths:8,  label:"6 to 8 months",  suffix:"-6-8-months"},
  {maxMonths:12, label:"8 to 12 months", suffix:"-8-12-months"}
];

// CAT fresh weekly packages: weight band -> handle.
var CAT_WEEKLY = [
  {max:5,   label:"Under 5kg",  handle:"5kg-dog-weekly-raw-cat-food"},
  {max:7.5, label:"5 to 7.5kg", handle:"7-5kg-dog-weekly-raw-cat-food"}
  // over 7.5kg -> bulk (handled in logic)
];

/* MIX variants - same 8 carried by every weekly package.
   tier: budget (Essentials) | premium (Complete + Chicken Proactive)
   protein flags used for ingredient filtering: EVERY animal species in the
   mix's published ingredient list, including offal and fish (sardines = fish).
   Main species first. Updated 22 Oct 2026 from the published declarations.
   26 Oct 2026: "grain" added to the three Complete mixes, whose published
   ingredients list wheat germ oil (conservative: the Grain choice excludes them). */
var MIXES = [
  {key:"ess_chicken",  name:"Essentials Chicken",        tier:"budget",  proteins:["chicken","beef"]},
  {key:"ess_duck",     name:"Essentials Duck",           tier:"budget",  proteins:["duck"]},
  {key:"ess_kangaroo", name:"Essentials Kangaroo",       tier:"budget",  proteins:["kangaroo","beef"]},
  {key:"ess_beef",     name:"Essentials Beef",           tier:"budget",  proteins:["beef","lamb"]},
  {key:"comp_proactive",name:"Complete Proactive Health",tier:"premium", proteins:["chicken","beef","fish","grain"], goal:"general"},
  {key:"comp_digest",  name:"Complete Digestion Support",tier:"premium", proteins:["duck","beef","fish","grain"], goal:"gut"},
  {key:"comp_mobility",name:"Complete Mobility Care",    tier:"premium", proteins:["chicken","kangaroo","beef","fish","grain"], goal:"joints"},
  {key:"chk_proactive",name:"Chicken Proactive Health",  tier:"premium", proteins:["chicken","beef"], goal:"general"}
];

/* DOG bulk: mix key -> {handle, opt, name}.
   2026-08 catalogue consolidation: the 8 per-mix bulk products were retired
   (set to DRAFT) and replaced by ONE active product `bulk-raw-dog-food` with
   options Protein x Weight (10..50kg). `opt` is the live Protein option value.
   Variant map key: '<handle>::<opt>::<size>kg'. */
var DOG_BULK = {
  ess_chicken:   {handle:"bulk-raw-dog-food", opt:"Chicken Essentials",         name:"Chicken Essentials Bulk"},
  ess_beef:      {handle:"bulk-raw-dog-food", opt:"Beef Essentials",            name:"Beef Essentials Bulk"},
  ess_duck:      {handle:"bulk-raw-dog-food", opt:"Duck Essentials",            name:"Duck Essentials Bulk"},
  ess_kangaroo:  {handle:"bulk-raw-dog-food", opt:"Kangaroo Essentials",        name:"Kangaroo Essentials Bulk"},
  comp_proactive:{handle:"bulk-raw-dog-food", opt:"Complete Proactive Health",  name:"Complete Proactive Health Bulk"},
  comp_digest:   {handle:"bulk-raw-dog-food", opt:"Complete Digestion Support", name:"Complete Digestion Support Bulk"},
  comp_mobility: {handle:"bulk-raw-dog-food", opt:"Complete Mobility Care",     name:"Complete Mobility Care Bulk"},
  chk_proactive: {handle:"bulk-raw-dog-food", opt:"Chicken Proactive Health",   name:"Chicken Proactive Health Bulk"}
};

/* FROZEN dog mixes (5kg = 10x 500g packs, next-day metro). Only ACTIVE products.
   No frozen Beef exists and never will; Duck/Kangaroo frozen are excluded for now.
   Any mix that has no frozen product falls back: premium -> Complete Proactive,
   budget/essentials -> Chicken Essentials.
   26 Oct 2026: the live frozen Turkey (variant 67855660220660, on sale since 23 Oct) is NOT in
   this map. Its published information calls it "Complementary pet food" (feed as part
   of a varied diet), so the planner never builds a meal plan on it.
   The UI frozen-block copy therefore speaks of "complete recipes". */
var DOG_FROZEN = {
  comp_proactive:{handle:"frozen-raw-dog-food", opt:"Complete Proactive Health",  name:"Frozen Complete Proactive Health Mix", variantId:"49071985131764"},
  comp_digest:   {handle:"frozen-raw-dog-food", opt:"Complete Digestion Support", name:"Frozen Complete Digestion Support Mix", variantId:"49071985164532"},
  comp_mobility: {handle:"frozen-raw-dog-food", opt:"Complete Mobility Care",     name:"Frozen Complete Mobility Care Mix",    variantId:"49071985197300"},
  ess_chicken:   {handle:"frozen-raw-dog-food", opt:"Chicken Essentials",         name:"Frozen Chicken Essentials Mix",        variantId:"49071985230068"}
};
function resolveFrozen(mix, allergies){
  if(!mix) return {fz:null, substituted:false, blocked:true};
  // Frozen products whose listed ingredients avoid the selection only. If none
  // is left (e.g. beef: every frozen mix lists beef or beef offal) the caller
  // must show the frozen block.
  var eligible = frozenEligibleMixes(allergies || []);
  if(!eligible.length) return {fz:null, substituted:false, blocked:true};
  var safeKeys = eligible.map(function(e){ return e.key; });
  // 1) the chosen mix itself, if it has a frozen product AND is allergy-safe.
  if(DOG_FROZEN[mix.key] && safeKeys.indexOf(mix.key) !== -1){
    return {fz:DOG_FROZEN[mix.key], substituted:false, blocked:false};
  }
  // 2) closest safe substitute: prefer same tier, else first eligible.
  var sameTier = eligible.filter(function(e){ return e.tier === mix.tier; })[0];
  var pick = sameTier || eligible[0];
  return {fz:DOG_FROZEN[pick.key], substituted:true, blocked:false};
}

// CAT bulk: protein -> handle.
var CAT_BULK = {
  chicken:  {handle:"bulk-cat-food", opt:"Chicken",  name:"Chicken Raw Cat Food Bulk"},
  duck:     {handle:"bulk-cat-food", opt:"Duck",     name:"Duck Raw Cat Food Bulk"},
  kangaroo: {handle:"bulk-cat-food", opt:"Kangaroo", name:"Kangaroo Raw Cat Food Bulk"}
};
var CAT_FRESH_PROTEINS = ["chicken","duck","kangaroo"]; // fresh cat packs carry these only

/* CAT MIXES - cats have their own dedicated Essentials range only (Chicken,
   Duck, Kangaroo). The dog Complete range is NOT made for cats, so the cat
   path never offers it and the premium/budget priority step is skipped. */
var CAT_MIXES = [
  {key:"ess_chicken",  name:"Chicken Essentials",  tier:"budget", proteins:["chicken","beef"]},
  {key:"ess_duck",     name:"Duck Essentials",     tier:"budget", proteins:["duck"]},
  {key:"ess_kangaroo", name:"Kangaroo Essentials", tier:"budget", proteins:["kangaroo","beef"]}
];
// Cat weekly variant map uses the dog 'Essentials X' option label.
var CAT_WEEKLY_OPTION = {ess_chicken:"Essentials Chicken", ess_duck:"Essentials Duck", ess_kangaroo:"Essentials Kangaroo"};
var CAT_MIX_PROTEIN = {ess_chicken:"chicken", ess_duck:"duck", ess_kangaroo:"kangaroo"};

/* ---------------------------------------------------------------------------
   COMPLEMENTS - treats, bones/offal and single top-up bags.
   2026-08 catalogue consolidation: the individual bone/offal products were
   replaced by TWO consolidated products with a single `Cut` option:
     dogs -> `raw-dog-offal-bones` (18 cuts)
     cats -> `raw-cat-offal`       (6 cat-safe cuts)
   and the small mix bags were replaced by `complete-raw-mixes`
   (Mix x Weight 250g/500g/1kg/10kg).
   Variant map key for all of these: '<handle>::<opt>' / '<handle>::<opt>::<size>'.
   `price` is a FALLBACK only - the UI overrides it with the live Shopify price.
   `species` gates the tile: 'dog' | 'cat' | 'both'.
   --------------------------------------------------------------------------- */

/* CHOMPERZ - air-dried treats, their own products. All three are still DRAFT,
   so they render as "coming soon" until Shopify marks them active + in stock. */
var CHOMPERZ = [
  {key:"chomperz_chicken_necks", name:"CHOMPERZ Chicken Necks", price:14.95, group:"chomperz", sku:"CPZ-CN-100G", handle:"chomperz-chicken-necks", variantId:"48006147670260", gated:true, defaultAvailable:false, airdried:true, species:"both", proteins:["chicken"]},
  {key:"chomperz_sardines",      name:"CHOMPERZ Sardines",     price:12.95, group:"chomperz", sku:"CPZ-SD-100G", handle:"chomperz-sardines", variantId:"48006151176436", gated:true, defaultAvailable:false, airdried:true, species:"both", proteins:["fish"]},
  {key:"chomperz_roo_jerky",     name:"CHOMPERZ Kangaroo Jerky",price:16.95, group:"chomperz", sku:"CPZ-KJ-100G", handle:"chomperz-kangaroo-jerky", variantId:"48006163726580", gated:true, defaultAvailable:false, airdried:true, species:"both", proteins:["kangaroo"]},
];

/* 26 Oct 2026: ingredient flags for every raw extra, so the "avoid" choices filter
   extras too. Each cut is single-ingredient (published); species from the cut name,
   Green Tripe = beef (published: "sourced from Australian grass-fed beef"). */
var TREAT_FLAGS = {
  d_duck_necks:["duck"], d_chicken_necks:["chicken"], d_chicken_frames:["chicken"], d_duck_frames:["duck"],
  d_lamb_marrow:["lamb"], d_duck_feet:["duck"], d_duck_wings:["duck"], d_duck_heads:["duck"],
  d_pig_trotters:["pork"], d_lambs_head:["lamb"], d_beef_liver:["beef"], d_beef_kidney:["beef"],
  d_lamb_hearts:["lamb"], d_duck_giblets:["duck"], d_green_tripe:["beef"], d_salmon_frame:["fish"],
  d_salmon_heads:["fish"], d_sardines:["fish"],
  c_chicken_necks:["chicken"], c_chicken_wings:["chicken"], c_duck_feet:["duck"], c_duck_giblets:["duck"],
  c_lamb_hearts:["lamb"], c_sardines:["fish"]
};
/* DOG raw bones, chews and offal -> `raw-dog-offal-bones`, option `Cut`. */
var DOG_BONES_HANDLE = "raw-dog-offal-bones";
var DOG_BONES = [
  {key:"d_duck_necks",   name:"Duck Necks",        opt:"Duck Necks",        sku:"137", price:9.69,  group:"necks"},
  {key:"d_chicken_necks",name:"Chicken Necks",     opt:"Chicken Necks",     sku:"170", price:6.10,  group:"necks"},
  {key:"d_chicken_frames",name:"Chicken Frames",   opt:"Chicken Frames",    sku:"171", price:5.07,  group:"necks"},
  {key:"d_duck_frames",  name:"Duck Frames",       opt:"Duck Frames",       sku:"139", price:5.99,  group:"necks"},
  {key:"d_lamb_marrow",  name:"Lamb Marrow Bones", opt:"Lamb Marrow Bones", sku:"134", price:7.47,  group:"bones"},
  {key:"d_duck_feet",    name:"Duck Feet",         opt:"Duck Feet",         sku:"129", price:8.84,  group:"bones"},
  {key:"d_duck_wings",   name:"Large Duck Wings",  opt:"Large Duck Wings",  sku:"138", price:9.92,  group:"bones"},
  {key:"d_duck_heads",   name:"Duck Heads",        opt:"Duck Heads",        sku:"160", price:8.84,  group:"bones"},
  {key:"d_pig_trotters", name:"Pig Trotters",      opt:"Pig Trotters",      sku:"179", price:8.72,  group:"bones"},
  {key:"d_lambs_head",   name:"Lambs Head",        opt:"Lambs Head",        sku:"188", price:18.64, group:"bones"},
  {key:"d_beef_liver",   name:"Beef Liver",        opt:"Beef Liver",        sku:"175", price:6.84,  group:"offal"},
  {key:"d_beef_kidney",  name:"Beef Kidney",       opt:"Beef Kidney",       sku:"185", price:7.58,  group:"offal"},
  {key:"d_lamb_hearts",  name:"Lamb Hearts",       opt:"Lamb Hearts",       sku:"176", price:6.84,  group:"offal"},
  {key:"d_duck_giblets", name:"Duck Giblets",      opt:"Duck Giblets",      sku:"183", price:12.43, group:"offal"},
  {key:"d_green_tripe",  name:"Green Tripe",       opt:"Green Tripe",       sku:"190", price:9.12,  group:"offal"},
  {key:"d_salmon_frame", name:"Salmon Frame",      opt:"Salmon Frame",      sku:"174", price:7.35,  group:"fish"},
  {key:"d_salmon_heads", name:"Salmon Heads",      opt:"Salmon Heads",      sku:"173", price:7.07,  group:"fish"},
  {key:"d_sardines",     name:"Sardines",          opt:"Sardines",          sku:"130", price:9.92,  group:"fish"}
].map(function(t){ t.handle = DOG_BONES_HANDLE; t.species = "dog"; t.proteins = TREAT_FLAGS[t.key] || []; return t; });

/* CAT raw bones and offal -> `raw-cat-offal`, option `Cut`. Cat-safe cuts only. */
var CAT_BONES_HANDLE = "raw-cat-offal";
var CAT_BONES = [
  {key:"c_chicken_necks",name:"Chicken Necks", opt:"Chicken Necks", sku:"170", price:6.10,  group:"necks"},
  {key:"c_chicken_wings",name:"Chicken Wings", opt:"Chicken Wings", sku:"127", price:9.35,  group:"necks"},
  {key:"c_duck_feet",    name:"Duck Feet",     opt:"Duck Feet",     sku:"129", price:8.84,  group:"bones"},
  {key:"c_duck_giblets", name:"Duck Giblets",  opt:"Duck Giblets",  sku:"183", price:12.43, group:"offal"},
  {key:"c_lamb_hearts",  name:"Lamb Hearts",   opt:"Lamb Hearts",   sku:"176", price:6.84,  group:"offal"},
  {key:"c_sardines",     name:"Sardines",      opt:"Sardines",      sku:"130", price:9.92,  group:"fish"}
].map(function(t){ t.handle = CAT_BONES_HANDLE; t.species = "cat"; t.proteins = TREAT_FLAGS[t.key] || []; return t; });

/* SINGLE TOP-UP BAGS -> `complete-raw-mixes` (Mix x Weight). Dog mixes only.
   Offered as an optional extra bag of the mix the pet was matched with, so a
   customer can trial a flavour or top up between deliveries. */
var SINGLE_BAG_HANDLE = "complete-raw-mixes";
var SINGLE_BAG_SIZES = ["250g","500g","1kg"];
var SINGLE_BAG_OPT = {
  ess_chicken:"Chicken Essentials", ess_beef:"Beef Essentials", ess_duck:"Duck Essentials",
  ess_kangaroo:"Kangaroo Essentials", chk_proactive:"Chicken Proactive Health",
  comp_proactive:"Complete Proactive Health", comp_digest:"Complete Digestion Support",
  comp_mobility:"Complete Mobility Care"
};
var SINGLE_BAG_PRICE = {
  "Chicken Essentials":{"250g":4.10,"500g":7.58,"1kg":12.83},
  "Beef Essentials":{"250g":6.10,"500g":11.29,"1kg":20.86},
  "Duck Essentials":{"250g":5.70,"500g":9.83,"1kg":17.30},
  "Kangaroo Essentials":{"250g":5.68,"500g":10.02,"1kg":18.63},
  "Chicken Proactive Health":{"250g":5.07,"500g":9.35,"1kg":15.85},
  "Complete Digestion Support":{"250g":6.16,"500g":11.27,"1kg":20.71},
  "Complete Proactive Health":{"250g":5.25,"500g":9.80,"1kg":18.01},
  "Complete Mobility Care":{"250g":5.36,"500g":9.80,"1kg":18.01}
};
var SINGLE_BAGS = (function(){
  var out = [];
  Object.keys(SINGLE_BAG_OPT).forEach(function(mk){
    var opt = SINGLE_BAG_OPT[mk];
    SINGLE_BAG_SIZES.forEach(function(sz){
      out.push({
        key:"bag_"+mk+"_"+sz, name:opt+" "+sz, opt:opt, opt2:sz, mixKey:mk,
        handle:SINGLE_BAG_HANDLE, group:"bag", species:"dog", singleBag:true,
        proteins:(MIXES.filter(function(m){ return m.key === mk; })[0] || {proteins:[]}).proteins,
        sku:null, price:(SINGLE_BAG_PRICE[opt] && SINGLE_BAG_PRICE[opt][sz]) || 0
      });
    });
  });
  return out;
})();

/* Every complement the quiz can put in a cart, keyed by `key`. */
var ALL_TREATS = CHOMPERZ.concat(DOG_BONES, CAT_BONES, SINGLE_BAGS);

/* complementsFor: the tiles to show at the treats step.
   frozen orders ship air-dried only (raw bones and fresh bags go separately). */
/* 26 Oct 2026: `allergies` (optional) drops extras whose listed ingredient is excluded. */
function treatAllowed(t, allergies){ return mixAllowedByAllergies({proteins:(t && t.proteins) || []}, allergies); }
function complementsFor(species, isFrozen, mixKey, allergies){
  var sp = (species === "cat") ? "cat" : "dog";
  var out = CHOMPERZ.slice();
  if(isFrozen) return out.filter(function(t){ return treatAllowed(t, allergies); });
  out = out.concat(sp === "cat" ? CAT_BONES : DOG_BONES);
  if(sp === "dog" && mixKey && SINGLE_BAG_OPT[mixKey]){
    out = out.concat(SINGLE_BAGS.filter(function(b){ return b.mixKey === mixKey; }));
  }
  return out.filter(function(t){ return treatAllowed(t, allergies); });
}
function treatByKey(k){
  for(var i=0;i<ALL_TREATS.length;i++){ if(ALL_TREATS[i].key === k) return ALL_TREATS[i]; }
  return null;
}

/* ---------------------------------------------------------------------------
   FEEDING CALCULATION - ported verbatim from the live Ardam raw food calculator.
   Daily intake = weight(kg) * 1000 * pct, where pct depends on life stage.
   Activity adjusts +/-7%. Body condition is assumed ideal (the quiz doesn't ask).
   Rounds to nearest 5g (dog) / 1g (cat), floor 10g. Weekly kg from the midpoint.
   --------------------------------------------------------------------------- */
var FEEDING = {
  dog: {
    // pct of body weight per day, by life stage band
    p1:    {low:0.08, high:0.10, meals:"3 to 4 meals", name:"Puppy 2 to 4mo"},
    p2:    {low:0.06, high:0.08, meals:"3 to 4 meals", name:"Puppy 4 to 6mo"},
    p3:    {low:0.04, high:0.06, meals:"2 to 3 meals", name:"Puppy 6 to 8mo"},
    p4:    {low:0.03, high:0.04, meals:"2 to 3 meals", name:"Puppy 8 to 12mo"},
    adult: {low:0.02, high:0.03, meals:"1 to 2 meals", name:"Adult 12mo+"},
    step:5
  },
  cat: {
    k1:    {low:0.10, high:0.13, meals:"3 to 4 meals", name:"Kitten 2 to 4mo"},
    k2:    {low:0.06, high:0.10, meals:"3 to 4 meals", name:"Kitten 4 to 8mo"},
    k3:    {low:0.03, high:0.06, meals:"2 to 3 meals", name:"Kitten 8 to 12mo"},
    adult: {low:0.02, high:0.04, meals:"2 meals",      name:"Adult 12mo+"},
    step:1
  }
};
var ACT_ADJ = {low:-0.07, medium:0, high:0.07}; // activity modifier

function feedingStageKey(species, lifeStage, ageMonths){
  if(species === "cat"){
    if(lifeStage === "puppy" || (ageMonths && ageMonths < 12)){
      if(ageMonths <= 4) return "k1";
      if(ageMonths <= 8) return "k2";
      return "k3";
    }
    return "adult";
  }
  // dog
  if(lifeStage === "puppy"){
    var m = ageMonths || 6;
    if(m <= 4) return "p1";
    if(m <= 6) return "p2";
    if(m <= 8) return "p3";
    return "p4";
  }
  return "adult"; // adult or senior
}

function roundStep(n, step){ return Math.round(n/step)*step; }

// Returns {gLow, gHigh, gMid, weeklyKg, meals, stageName, pctLow, pctHigh}
function computeFeeding(answers){
  var species = answers.species === "cat" ? "cat" : "dog";
  var conf = FEEDING[species];
  var key = feedingStageKey(species, answers.lifeStage, answers.ageMonths);
  var s = conf[key] || conf.adult;
  var adj = (ACT_ADJ[answers.activity] || 0); // body condition assumed ideal (0)
  var low = s.low * (1 + adj);
  var high = s.high * (1 + adj);
  var w = Number(answers.weightKg) || 0;
  var gLow = roundStep(w * 1000 * low, conf.step);
  var gHigh = roundStep(w * 1000 * high, conf.step);
  if(gLow < 10) gLow = 10;
  if(gHigh < gLow) gHigh = gLow;
  var gMid = (gLow + gHigh) / 2;
  var weeklyKg = (gMid * 7) / 1000;
  return {
    gLow:gLow, gHigh:gHigh, gMid:gMid, weeklyKg:weeklyKg,
    meals:s.meals, stageName:s.name,
    pctLow:Math.round(low*1000)/10, pctHigh:Math.round(high*1000)/10
  };
}

/* Bulk supply plan: given weekly kg and a number of weeks, work out the total
   needed and snap UP to the nearest bag size. Bag ladder = first 10kg, then 5kg
   increments (10,15,20,25,...,50). Mirrors the on-site bulk size options. */
var BULK_LADDER = [10,15,20,25,30,35,40,45,50];
function snapBulkKg(totalKg){
  for(var i=0;i<BULK_LADDER.length;i++){ if(totalKg <= BULK_LADDER[i]) return BULK_LADDER[i]; }
  return BULK_LADDER[BULK_LADDER.length-1];
}
function bulkPlan(weeklyKg, weeks){
  var wk = weeks || 1;
  var totalNeeded = weeklyKg * wk;
  var bagKg = snapBulkKg(totalNeeded);
  return {weeks:wk, totalNeededKg:totalNeeded, bagKg:bagKg};
}

/* ---------------------------------------------------------------------------
   ALLERGY FILTERING
   --------------------------------------------------------------------------- */
function mixAllowedByAllergies(mix, allergies){
  if(!allergies || !allergies.length) return true;
  for(var i=0;i<allergies.length;i++){
    if(mix.proteins.indexOf(allergies[i]) !== -1) return false;
  }
  return true;
}

/* ---------------------------------------------------------------------------
   STEP 3 - choose the MIX variant from priority + allergies + health
   --------------------------------------------------------------------------- */
function chooseMix(opts){
  var priority = opts.priority || "premium";   // 'budget' | 'premium'
  var allergies = opts.allergies || [];
  var health = opts.health || [];
  var lifeStage = opts.lifeStage;              // 'puppy'|'adult'|'senior'

  var tier = (priority === "budget") ? "budget" : "premium";
  var pool = MIXES.filter(function(m){ return m.tier === tier && mixAllowedByAllergies(m, allergies); });

  // fallback: if the chosen tier is fully excluded by allergies, try the other tier
  if(!pool.length){
    pool = MIXES.filter(function(m){ return mixAllowedByAllergies(m, allergies); });
  }
  // 26 Oct 2026: nothing avoids every selected ingredient -> no match (null). Never
  // fall back to the whole catalogue: the caller shows a no-match result instead.
  if(!pool.length) return null;

  // PREMIUM: nudge by health goal / life stage
  if(tier === "premium"){
    // Senior dogs default to Mobility Care (locked Q2)
    var wantGoal = null;
    if(health.indexOf("gut") !== -1) wantGoal = "gut";
    else if(health.indexOf("joints") !== -1) wantGoal = "joints";
    else if(lifeStage === "senior") wantGoal = "joints";
    if(wantGoal){
      var match = pool.filter(function(m){ return m.goal === wantGoal; })[0];
      if(match) return match;
    }
    // default premium = Complete Proactive Health if allowed
    var def = pool.filter(function(m){ return m.key === "comp_proactive"; })[0];
    return def || pool[0];
  }

  // BUDGET: default cheapest (Chicken) then Duck/Kangaroo/Beef by allergy availability
  var order = ["ess_chicken","ess_duck","ess_kangaroo","ess_beef"];
  for(var i=0;i<order.length;i++){
    var m = pool.filter(function(x){ return x.key === order[i]; })[0];
    if(m) return m;
  }
  return pool[0];
}

/* ---------------------------------------------------------------------------
   STEP 4 - activity adjusts weight band (zoomies bumps up one band)
   --------------------------------------------------------------------------- */
function applyActivity(weightKg, activity){
  // activity: 'low' | 'medium' | 'high'
  // 'high' (constant zoomies) bumps up one band -> nudge the weight to next band
  if(activity === "high") return weightKg + 0.01 + bandBump(weightKg, "dog");
  return weightKg;
}
function bandBump(weightKg, species){
  var bands = species === "cat" ? CAT_WEEKLY : DOG_WEEKLY;
  for(var i=0;i<bands.length;i++){
    if(weightKg <= bands[i].max){
      // push to just over this band's max so it lands in the next band
      if(i < bands.length-1) return (bands[i].max - weightKg) + 0.01;
      return 0;
    }
  }
  return 0;
}

function pickDogWeeklyBand(weightKg){
  for(var i=0;i<DOG_WEEKLY.length;i++){ if(weightKg <= DOG_WEEKLY[i].max) return DOG_WEEKLY[i]; }
  return DOG_WEEKLY[DOG_WEEKLY.length-1];
}
function pickCatWeeklyBand(weightKg){
  for(var i=0;i<CAT_WEEKLY.length;i++){ if(weightKg <= CAT_WEEKLY[i].max) return CAT_WEEKLY[i]; }
  return null; // over 7.5kg -> bulk
}
function pickPuppyAgeBand(ageMonths){
  for(var i=0;i<PUPPY_AGE_BANDS.length;i++){ if(ageMonths <= PUPPY_AGE_BANDS[i].maxMonths) return PUPPY_AGE_BANDS[i]; }
  return PUPPY_AGE_BANDS[PUPPY_AGE_BANDS.length-1];
}

/* PUPPY weight caps that actually exist per age band (real Shopify catalog).
   Handle prefix kg = UPPER bound of the band. Caps are irregular per age band. */
var PUPPY_CAPS = {
  "-2-4-months":  [1.25,2.5,5,7.5,10,12.5,15,20,25],
  "-4-6-months":  [2.5,5,7.5,10,15,20,25,30],
  "-6-8-months":  [2.5,5,7.5,10,15,20,25,30,35,40],
  "-8-12-months": [2.5,5,7.5,10,15,20,25,30,40]
};
// kg cap -> handle prefix (handles "1-25","2-5","7-5","12-5" decimals)
function capToHandlePrefix(cap){
  if(cap === 1.25) return "1-25kg";
  if(cap === 2.5)  return "2-5kg";
  if(cap === 7.5)  return "7-5kg";
  if(cap === 12.5) return "12-5kg";
  return cap + "kg";
}
// Resolve a real puppy product handle for (weightKg, ageSuffix). Snaps to the
// smallest existing cap >= weight; if heavier than all caps, uses the largest.
function resolvePuppyHandle(weightKg, ageSuffix){
  var caps = PUPPY_CAPS[ageSuffix] || PUPPY_CAPS["-8-12-months"];
  var chosen = null;
  for(var i=0;i<caps.length;i++){ if(weightKg <= caps[i]){ chosen = caps[i]; break; } }
  if(chosen === null) chosen = caps[caps.length-1];
  return capToHandlePrefix(chosen) + "-dog-weekly-raw-dog-food" + ageSuffix;
}

/* ---------------------------------------------------------------------------
   MAIN - build recommendation
   answers = {
     species:'dog'|'cat', petName, lifeStage:'puppy'|'adult'|'senior',
     ageMonths (puppy only), weightKg, activity:'low'|'medium'|'high',
     health:[], allergies:[], currentBrand, priority:'budget'|'premium',
     format:'weekly'|'bulk', deliveryPref, treats:[keys]
   }
   --------------------------------------------------------------------------- */
function buildRecommendation(answers){
  var a = answers;
  var rec = {petName:a.petName, species:a.species, reasons:[], product:null, mix:null, format:a.format||"weekly"};
  var adjWeight = applyActivity(a.weightKg, a.activity);
  // Feeding numbers (used on the bulk route and available everywhere).
  rec.feeding = computeFeeding(a);
  var mix = chooseMix({priority:a.priority, allergies:a.allergies, health:a.health, lifeStage:a.lifeStage});
  rec.mix = mix;
  // 26 Oct 2026: explicit no-match when no recipe avoids every selected ingredient.
  if(noMatchFor(a.species, a.allergies) || !mix){
    rec.noMatch = true; rec.mix = null; rec.product = null; rec.treats = [];
    rec.reasons.push("Based on their listed ingredients, every "+(a.species==="cat"?"cat":"dog")+" recipe we make includes at least one of "+(a.allergies||[]).join(", ")+", so we can't match a plan here.");
    return rec;
  }

  if(a.species === "cat"){
    var catBand = pickCatWeeklyBand(adjWeight);
    // cat mix limited to chicken/duck/kangaroo. The owner can swap the flavour
    // on the result screen (a.catMixOverride), so honour that when it is set and
    // still allergy-safe; otherwise fall back to the matched default.
    var catProtein = catProteinForMix(mix, a.allergies);
    if(a.catMixOverride && CAT_FRESH_PROTEINS.indexOf(a.catMixOverride) !== -1
        && catProteinAllowed(a.catMixOverride, a.allergies)){
      catProtein = a.catMixOverride;
    }
    var catMixKey = {chicken:"ess_chicken", duck:"ess_duck", kangaroo:"ess_kangaroo"}[catProtein];
    var catMixMeta = CAT_MIXES.filter(function(m){ return m.key === catMixKey; })[0];
    if(catMixMeta) rec.mix = catMixMeta;
    if(a.format === "bulk" || !catBand){
      var cb = CAT_BULK[catProtein] || CAT_BULK.chicken;
      rec.format = "bulk";
      rec.product = {kind:"cat_bulk", handle:cb.handle, name:cb.name, protein:catProtein};
      if(!catBand) rec.reasons.push("No fresh weekly pack exists above 7.5kg, so we matched a bulk bag.");
      else rec.reasons.push("You chose bulk, so we matched a 10kg bulk bag in "+catProtein+".");
    } else {
      rec.product = {kind:"cat_weekly", handle:catBand.handle, name:"Fresh Raw Cat Food "+catBand.label, band:catBand.label, protein:catProtein};
      rec.reasons.push("Sized for a cat in the "+catBand.label+" range.");
    }
    rec.reasons.push("Protein: "+catProtein+(a.allergies&&a.allergies.length?" (avoiding "+a.allergies.join(", ")+")":"")+".");
    rec.treats = filterTreats(a.treats, a.format, a.allergies);
    return rec;
  }

  // DOG
  var band = pickDogWeeklyBand(adjWeight);
  if(a.activity === "high") rec.reasons.push("Constant zoomies, so we bumped up one weight band for extra fuel.");

  if(a.format === "frozen"){
    var fzr = resolveFrozen(mix, a.allergies);
    if(fzr.blocked){
      // No frozen product avoids the customer's allergies (every frozen mix
      // contains chicken). Signal a block so the UI steers them to weekly/bulk;
      // never recommend a product the pet is allergic to.
      rec.frozenBlocked = true;
      rec.product = null;
      rec.reasons.push("Our frozen range doesn't have a flavour that avoids "+(a.allergies||[]).join(", ")+", so a frozen plan isn't a fit here.");
      rec.treats = filterTreats(a.treats, a.format, a.allergies);
      return rec;
    }
    rec.product = {kind:"dog_frozen", handle:fzr.fz.handle, name:fzr.fz.name, variantId:fzr.fz.variantId, mixKey:mix.key};
    rec.reasons.push("Frozen 5kg pack (10x 500g portions), with next-day delivery available to metro areas.");
    if(fzr.substituted) rec.reasons.push("Matched the closest available frozen mix that avoids "+((a.allergies&&a.allergies.length)?a.allergies.join(", "):"your allergies")+".");
    else rec.reasons.push("Mix: "+fzr.fz.name.replace(/^Frozen /,'')+(a.allergies&&a.allergies.length?", avoiding "+a.allergies.join(", "):"")+".");
    rec.treats = filterTreats(a.treats, a.format, a.allergies);
    return rec;
  } else if(a.format === "bulk"){
    var db = DOG_BULK[mix.key] || DOG_BULK.ess_chicken;
    var weeks = a.bulkWeeks || 2;
    var plan = bulkPlan(rec.feeding.weeklyKg, weeks);
    rec.bulk = plan;
    rec.product = {kind:"dog_bulk", handle:db.handle, name:db.name + " " + plan.bagKg + "kg", mixKey:mix.key, bagKg:plan.bagKg};
    rec.reasons.push("At about "+rec.feeding.gLow+" to "+rec.feeding.gHigh+"g a day, "+(a.petName||"your dog")+" eats roughly "+rec.feeding.weeklyKg.toFixed(1)+"kg a week.");
    rec.reasons.push("For "+plan.weeks+" week"+(plan.weeks>1?"s":"")+" that is about "+plan.totalNeededKg.toFixed(1)+"kg, so we matched the "+plan.bagKg+"kg "+mix.name+" bulk bag.");
    rec.reasons.push("Bulk is unportioned, so you portion and store it yourself for the best value.");
  } else if(a.lifeStage === "puppy"){
    var ageBand = pickPuppyAgeBand(a.ageMonths || 6);
    var puppyHandle = resolvePuppyHandle(adjWeight, ageBand.suffix);
    rec.product = {kind:"dog_puppy", handle:puppyHandle, name:"Puppy Weekly "+band.label+" / "+ageBand.label, band:band.label, age:ageBand.label};
    rec.reasons.push("Puppy formula sized for "+band.label+" and "+ageBand.label+".");
  } else {
    rec.product = {kind:"dog_weekly", handle:band.handle, name:"Weekly Package "+band.label, band:band.label};
    rec.reasons.push("Sized for a dog in the "+band.label+" range.");
    if(a.lifeStage === "senior") rec.reasons.push("As a senior, we defaulted the mix to Complete Mobility Care for joint support.");
  }

  // 26 Oct 2026: label by the matched mix's own range (a premium request can fall back to Essentials).
  rec.reasons.push("Mix: "+mix.name+(mix.tier==="budget"?" (great value)":" (premium, complete)")+(a.allergies&&a.allergies.length?", avoiding "+a.allergies.join(", "):"")+".");
  if(a.activity === "low") rec.reasons.push("Lower-energy "+(a.lifeStage==="puppy"?"pup":"dog")+", so feed toward the lower end of the range.");
  rec.treats = filterTreats(a.treats, a.format, a.allergies);
  return rec;
}

function catProteinForMix(mix, allergies){
  // map chosen mix to a cat-available protein, respecting allergies
  var pref = mix ? mix.proteins.filter(function(p){ return CAT_FRESH_PROTEINS.indexOf(p) !== -1; })[0] : null;
  var order = ["chicken","duck","kangaroo"];
  if(allergies && allergies.length){
    // filter on the cat mix's full ingredient flags (e.g. cat chicken also lists beef offal)
    order = order.filter(function(p){ return catProteinAllowed(p, allergies); });
  }
  if(pref && order.indexOf(pref) !== -1) return pref;
  return order[0] || null; // 26 Oct 2026: no allowed cat recipe -> null, never an excluded one
}

function catProteinAllowed(p, allergies){
  var cm = CAT_MIXES.filter(function(m){ return CAT_MIX_PROTEIN[m.key] === p; })[0];
  return cm ? mixAllowedByAllergies(cm, allergies) : !(allergies && allergies.indexOf(p) !== -1);
}

function filterTreats(keys, format, allergies){
  if(!keys || !keys.length) return [];
  // 26 Oct 2026: never put an extra in the cart whose listed ingredient is excluded.
  var sel = ALL_TREATS.filter(function(t){ return keys.indexOf(t.key) !== -1 && treatAllowed(t, allergies); });
  // On frozen orders, only air-dried treats can be added. Raw bones/complements
  // ship separately, so keep only the air-dried range.
  if(format === "frozen") sel = sel.filter(function(t){ return t.airdried === true; });
  return sel;
}

/* ===========================================================================
   VARIETY MEAL PLANNER  (Specific vs Variety)
   Three separate paths (weekly / bulk / frozen), each with its own unit and
   mix-count rule. All share ONE editable allocation model: a list of
   {mixKey, units} that the user can rebalance, then we resolve to cart lines.
   Rules locked with the owner 4 Jun 2026 (see VARIETY_SPEC.md).
   =========================================================================== */

/* The bulk size variants that actually exist per mix (10..50kg ladder).
   A mix assigned k 10kg-blocks => ONE bag variant of (k*10)kg, qty 1.
   We cap at 50kg (the largest bag). If a user somehow assigns >5 blocks to a
   single mix, the remainder spills into a second bag of the same mix. */
var BULK_BLOCK_KG = 10;
var BULK_MAX_BAG = 50;

/* varietyCapacity: how many assignable units the chosen route gives, and the
   max number of distinct mixes that unlocks.
     bulk   -> unit 'block' (10kg). totalUnits = round food UP to whole 10kg blocks.
               maxMixes = totalUnits (each block can be a different mix), but a
               variety needs >=20kg (2 blocks) to be meaningful.
     weekly -> unit 'pack'. totalUnits = weeks. maxMixes = weeks.
     frozen -> unit 'box' (5kg). totalUnits = ceil(weeklyKg/5). maxMixes = totalUnits.
*/
function varietyCapacity(format, feeding, opts){
  opts = opts || {};
  var weeklyKg = feeding && feeding.weeklyKg ? feeding.weeklyKg : 0;
  if(format === 'bulk'){
    var weeks = opts.bulkWeeks || 2;
    var totalKg = weeklyKg * weeks;
    var blocks = Math.max(1, Math.ceil(totalKg / BULK_BLOCK_KG));
    return {unit:'block', unitKg:BULK_BLOCK_KG, totalUnits:blocks, maxMixes:blocks, weeks:weeks, totalKg:blocks*BULK_BLOCK_KG};
  }
  if(format === 'frozen'){
    var boxes = Math.max(1, Math.ceil(weeklyKg / 5));
    return {unit:'box', unitKg:5, totalUnits:boxes, maxMixes:boxes, totalKg:boxes*5};
  }
  // weekly
  var wks = Math.max(1, opts.weeks || 1);
  return {unit:'pack', unitKg:null, totalUnits:wks, maxMixes:wks, weeks:wks};
}

/* frozenEligibleMixes: the 4 frozen products filtered by allergies.
   Returns [{key,name,variantId,proteins}]. */
function frozenEligibleMixes(allergies){
  var keys = ['comp_proactive','comp_digest','comp_mobility','ess_chicken'];
  var out = [];
  keys.forEach(function(k){
    var mix = MIXES.filter(function(m){ return m.key === k; })[0];
    var fz = DOG_FROZEN[k];
    if(!mix || !fz) return;
    if(!mixAllowedByAllergies(mix, allergies)) return;
    out.push({key:k, name:fz.name.replace(/^Frozen /,''), variantId:fz.variantId, proteins:mix.proteins, tier:mix.tier, goal:mix.goal});
  });
  return out;
}

/* varietyPool: eligible mixes for a path, allergy-filtered, ordered with the
   recommended seed first (premium complete -> health-goal match -> essentials).
   For frozen, the pool is the 4 frozen products. For bulk/weekly it is all 8
   MIXES that survive allergy filtering. */
function varietyPool(format, opts){
  opts = opts || {};
  var allergies = opts.allergies || [];
  // CAT: only the 3 cat Essentials, allergy-filtered. No Complete range, no
  // priority tier. Order chicken -> duck -> kangaroo (allergy-safe first).
  if(opts.species === 'cat'){
    return CAT_MIXES
      .filter(function(m){ return mixAllowedByAllergies(m, allergies); })
      .map(function(m){ return {key:m.key, name:m.name, proteins:m.proteins, tier:m.tier}; });
  }
  if(format === 'frozen'){
    return frozenEligibleMixes(allergies);
  }
  var pool = MIXES.filter(function(m){ return mixAllowedByAllergies(m, allergies); });
  // Order: the chooseMix recommendation first, then remaining premium, then budget.
  var seed = chooseMix({priority:opts.priority, allergies:allergies, health:opts.health, lifeStage:opts.lifeStage});
  var ordered = [];
  if(seed) ordered.push(seed);
  pool.filter(function(m){ return m.tier==='premium' && (!seed||m.key!==seed.key); }).forEach(function(m){ ordered.push(m); });
  pool.filter(function(m){ return m.tier==='budget' && (!seed||m.key!==seed.key); }).forEach(function(m){ ordered.push(m); });
  return ordered.map(function(m){ return {key:m.key, name:m.name, proteins:m.proteins, tier:m.tier, goal:m.goal}; });
}

/* defaultAllocation: seed the editable screen.
   - weekly: ONE pack per flavour (1 pack to first N=totalUnits distinct mixes).
             1 unit -> 1 mix x1; 2 units -> 2 mixes x1 each; 3 -> 3 mixes x1; ...
             If pool smaller than units, double up on the first mix.
   - bulk:   one block per mix across as many mixes as units allow (same as weekly
             but the unit is a 10kg block). Owner can rebalance to e.g. 20/10.
   - frozen: one box per mix across eligible frozen mixes; remainder doubles first.
   Returns [{mixKey, units}] summing to totalUnits. */
function defaultAllocation(pool, totalUnits){
  var alloc = [];
  if(!pool.length || totalUnits < 1) return alloc;
  var distinct = Math.min(totalUnits, pool.length);
  for(var i=0;i<distinct;i++){ alloc.push({mixKey:pool[i].key, units:1}); }
  // spread any remaining units onto existing lines, starting at the first
  var remaining = totalUnits - distinct;
  var j = 0;
  while(remaining > 0){ alloc[j % alloc.length].units += 1; remaining--; j++; }
  return alloc;
}

/* allocationUnits: sum of units in an allocation. */
function allocationUnits(alloc){
  return (alloc||[]).reduce(function(s,a){ return s + (a.units||0); }, 0);
}

/* mixByKey helper across MIXES + frozen names. */
function mixMeta(key, format){
  if(format === 'frozen' && DOG_FROZEN[key]){
    var fm = MIXES.filter(function(m){ return m.key===key; })[0] || {};
    return {key:key, name:DOG_FROZEN[key].name.replace(/^Frozen /,''), variantId:DOG_FROZEN[key].variantId, tier:fm.tier, goal:fm.goal, proteins:fm.proteins};
  }
  return MIXES.filter(function(m){ return m.key===key; })[0] || {key:key, name:key};
}

/* buildVarietyCart: resolve an allocation to cart lines [{variantId, qty, name, kg}].
   Needs the variant map (window.ARDAM_VARIANT_MAP) at call time for weekly/bulk.
   - bulk:   per mix, units k -> bags. Whole bag while <=5 blocks (<=50kg): one
             (k*10)kg bag qty 1. >5 blocks spills into a 50kg bag + remainder bag.
             Map key '<bulkHandle>::<size>kg'.
   - weekly: per mix, qty = units packs of the band handle.
             Map key '<weeklyBandHandle>::<MixName>'.
   - frozen: per mix, qty = units boxes of that frozen product variantId.
   Returns {lines:[...], unresolved:[...]}. */
function bagSizesForBlocks(blocks){
  // split blocks (each 10kg) into sellable bag sizes (max 50kg per bag)
  var sizes = [];
  var maxBlocks = BULK_MAX_BAG / BULK_BLOCK_KG; // 5
  while(blocks > 0){
    var take = Math.min(blocks, maxBlocks);
    sizes.push(take * BULK_BLOCK_KG);
    blocks -= take;
  }
  return sizes;
}
function buildVarietyCart(format, allocation, ctx){
  ctx = ctx || {};
  var map = (typeof window !== 'undefined' && window.ARDAM_VARIANT_MAP) ? window.ARDAM_VARIANT_MAP : (ctx.variantMap || {});
  var lines = [], unresolved = [];
  var isCat = ctx.species === 'cat';
  (allocation||[]).forEach(function(a){
    if(!a.units) return;
    var meta = isCat ? (CAT_MIXES.filter(function(m){return m.key===a.mixKey;})[0] || {key:a.mixKey,name:a.mixKey}) : mixMeta(a.mixKey, format);
    if(isCat){
      if(format === 'bulk'){
        var cprot = CAT_MIX_PROTEIN[a.mixKey] || 'chicken';
        var cb = CAT_BULK[cprot];
        if(!cb){ unresolved.push(meta.name); return; }
        bagSizesForBlocks(a.units).forEach(function(sz){
          var cv = map[cb.handle+'::'+cb.opt+'::'+sz+'kg'] || map[cb.handle+'::'+cb.opt] || map[cb.handle+'::'+sz+'kg'];
          if(cv) lines.push({variantId:cv, qty:1, name:meta.name+' '+sz+'kg', kg:sz});
          else unresolved.push(meta.name+' '+sz+'kg');
        });
      } else { // cat weekly
        var cbh = ctx.weeklyHandle;
        var opt = CAT_WEEKLY_OPTION[a.mixKey];
        if(!cbh || !opt){ unresolved.push(meta.name); return; }
        var cwv = map[cbh+'::'+opt] || map[cbh];
        if(cwv) lines.push({variantId:cwv, qty:a.units, name:meta.name, kg:null});
        else unresolved.push(meta.name);
      }
      return;
    }
    if(format === 'frozen'){
      var vid = meta.variantId || (DOG_FROZEN[a.mixKey] && DOG_FROZEN[a.mixKey].variantId);
      if(vid) lines.push({variantId:vid, qty:a.units, name:meta.name, kg:a.units*5});
      else unresolved.push(meta.name);
    } else if(format === 'bulk'){
      var db = DOG_BULK[a.mixKey];
      if(!db){ unresolved.push(meta.name); return; }
      bagSizesForBlocks(a.units).forEach(function(sz){
        var v = map[db.handle+'::'+db.opt+'::'+sz+'kg'] || map[db.handle+'::'+db.opt] || map[db.handle+'::'+sz+'kg'];
        if(v) lines.push({variantId:v, qty:1, name:meta.name+' '+sz+'kg', kg:sz});
        else unresolved.push(meta.name+' '+sz+'kg');
      });
    } else { // weekly
      var bandHandle = ctx.weeklyHandle;
      if(!bandHandle){ unresolved.push(meta.name); return; }
      var wv = map[bandHandle+'::'+meta.name] || map[bandHandle];
      if(wv) lines.push({variantId:wv, qty:a.units, name:meta.name, kg:null});
      else unresolved.push(meta.name);
    }
  });
  return {lines:lines, unresolved:unresolved};
}

/* buildVarietyRecommendation: variety analogue of buildRecommendation. Computes
   feeding, capacity, pool, default allocation, and a human summary. The UI may
   override `allocation` from the editable screen before building the cart. */
function buildVarietyRecommendation(answers){
  var a = answers;
  var feeding = computeFeeding(a);
  var cap = varietyCapacity(a.format, feeding, {bulkWeeks:a.bulkWeeks, weeks:a.varietyWeeks});
  var pool = varietyPool(a.format, {species:a.species, allergies:a.allergies, priority:a.priority, health:a.health, lifeStage:a.lifeStage});
  // 26 Oct 2026: an allocation kept from before a back-navigation is only reused when
  // every mix in it is still in the (ingredient-filtered) pool.
  var poolKeys = pool.map(function(m){ return m.key; });
  var allocOk = a.allocation && a.allocation.length && a.allocation.every(function(x){ return poolKeys.indexOf(x.mixKey) !== -1; });
  var allocation = allocOk ? a.allocation : defaultAllocation(pool, cap.totalUnits);
  return {
    petName:a.petName, species:a.species, format:a.format, planType:'variety', noMatch:(pool.length === 0),
    feeding:feeding, capacity:cap, pool:pool, allocation:allocation,
    treats:filterTreats(a.treats, a.format, a.allergies)
  };
}

/* noMatchFor: true when no recipe for this species avoids every selected ingredient. */
function noMatchFor(species, allergies){
  var list = (species === "cat") ? CAT_MIXES : MIXES;
  return !list.some(function(m){ return mixAllowedByAllergies(m, allergies); });
}

// Export for browser + node
var QuizEngine = {buildRecommendation:buildRecommendation, chooseMix:chooseMix, computeFeeding:computeFeeding, bulkPlan:bulkPlan, snapBulkKg:snapBulkKg, MIXES:MIXES, CAT_MIXES:CAT_MIXES, CAT_MIX_PROTEIN:CAT_MIX_PROTEIN, DOG_WEEKLY:DOG_WEEKLY, CAT_WEEKLY:CAT_WEEKLY, CHOMPERZ:CHOMPERZ, DOG_BONES:DOG_BONES, CAT_BONES:CAT_BONES, SINGLE_BAGS:SINGLE_BAGS, SINGLE_BAG_SIZES:SINGLE_BAG_SIZES, SINGLE_BAG_OPT:SINGLE_BAG_OPT, ALL_TREATS:ALL_TREATS, complementsFor:complementsFor, treatByKey:treatByKey, DOG_BULK:DOG_BULK, CAT_BULK:CAT_BULK, DOG_FROZEN:DOG_FROZEN, BULK_LADDER:BULK_LADDER, varietyCapacity:varietyCapacity, frozenEligibleMixes:frozenEligibleMixes, varietyPool:varietyPool, defaultAllocation:defaultAllocation, allocationUnits:allocationUnits, buildVarietyCart:buildVarietyCart, buildVarietyRecommendation:buildVarietyRecommendation, mixAllowedByAllergies:mixAllowedByAllergies, treatAllowed:treatAllowed, noMatchFor:noMatchFor, pickDogWeeklyBand:pickDogWeeklyBand, applyActivity:applyActivity};
if (typeof module !== "undefined" && module.exports){ module.exports = QuizEngine; }
if (typeof window !== "undefined"){ window.QuizEngine = QuizEngine; }
